import React from "react";
import { FileUploadProps } from "../fileUploadTypes";
import FileAttachListItem from "./FileAttachListItem";

interface FileAttachListProps {
  files: FileUploadProps[];
  downloadingId: number;
  handleDownload: (file: FileUploadProps) => void;
  handleDelete: (fileId: number, index: number) => void;
  getFileIcon: (fileName: string, hasError: boolean) => React.ReactNode;
  maxFileSize: number;
}

const FileAttachList: React.FC<FileAttachListProps> = ({
  files,
  downloadingId,
  handleDownload,
  handleDelete,
  getFileIcon,
  maxFileSize,
}) => {
  return (
    <div className="file-attach__list">
      {files.map((file, i) => (
        <FileAttachListItem
          key={file.file_name}
          file={file}
          index={i}
          downloadingId={downloadingId}
          handleDownload={handleDownload}
          handleDelete={handleDelete}
          getFileIcon={getFileIcon}
          maxFileSize={maxFileSize}
        />
      ))}
    </div>
  );
};

export default FileAttachList;
